<div class="mt-container" [class.mt-is-mobile]="mobileQuery.matches">
  <mat-sidenav-container class="mt-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 64 : 0">
    <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [opened]="mobileQuery.matches && false"
      [fixedInViewport]="mobileQuery.matches" fixedTopGap="64">
      <div class="logo-container">
        <!-- <img
        src="../../../../assets/img/logo/logo_light.svg"
        height="40"
        width="90%"
        /> -->
        <img [src]="'./../../../assets/img/logo/logo_light.svg'" alt="Logo" height="40" width="90%" />
      </div>

      <mat-nav-list class="mt-side-nav-list">
        @for (nav of navItems; track nav.name) {
          @if (shouldShow(nav.show)) {
            <a mat-list-item routerLink="{{ nav.path }}" routerLinkActive="mt-nav-active"
              (click)="navigateTo(nav)" class="mt-side-nav-list-item">
              <span [ngClass]="nav.icon" class="navIcon"></span>
              <span class="navItemlabel" matBadge="New" matBadgeOverlap="true" matBadgeSize="small" matBadgeColor="accent"
              [matBadgeHidden]="!nav.isNew">{{ nav.name.toLowerCase() | translate }}</span>
            </a>
          }
          } @empty {
          <a mat-list-item>There are no items.</a>
        }
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-toolbar class="mt-toolbar" [ngClass]="snav.opened ? 'side-bar-open' : 'side-bar-closed'">
        <mt-btn class="icon" (onAction)="snav.toggle()">
          <span class="ic_burger"></span>
        </mt-btn>
        <a class="mt-app-name logoCode">
          @if (instituteImgUrl) {
            <img [src]="instituteImgUrl" height="40" class="mt-client-logo-url mt-client-logo-url" />
            <div class="instituteNumber">
              <div class="triangle"></div>
              {{ instituteName }}
            </div>
          }
        </a>
        <span class="sp"></span>
        <mt-btn matBadgeColor="accent" matBadge="{{ notifyCount }}" matBadgeOverlap="true" (click)="openDialog()">
          <mat-icon>notifications_active</mat-icon>
        </mt-btn>
        <!-- <mt-btn
        *ngIf="false"
        class="icon {{ isDark ? 'white' : '' }}"
        matTooltip="{{ isDark ? 'Light' : 'Dark' }} Mode"
        (onAction)="onSetTheme({ checked: !isDark })"
        >
        <mat-icon>{{ isDark ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </mt-btn> -->
      <mt-btn class="nobg" fxHide="false" [matMenuTriggerFor]="menuUser">
        <mat-icon>account_circle</mat-icon> &nbsp;{{ loggedInUser }}
      </mt-btn>

      <!-- <mt-btn *ngIf="showButton" (onAction)="addToHomeScreen()" class="add-to-home-screen-btn"
      >Add to home screen
    </mt-btn> -->

    <mat-menu #menuUser="matMenu">
      <button mat-menu-item [matMenuTriggerFor]="languageBox">
        <mat-icon>translate</mat-icon> {{ "Change Language" | translate }}
      </button>
      <button mat-menu-item (click)="refreshSyncData()">
        Sync manager
      </button>
      <button mat-menu-item (click)="clearCache()">Clear Cache</button>
      <button mat-menu-item (click)="logoutModal = true">Sign out</button>
    </mat-menu>

    <mat-menu #languageBox="matMenu">
      @for (language of languages; track language) {
        <button mat-menu-item class="nobg" color="primary" (click)="changeLanguage(language.unicode)">
          {{ language.name }}
        </button>
      }
    </mat-menu>
  </mat-toolbar>

  <div class="mt-content-wrapper" [ngClass]="mobileQuery.matches ? 'mt-mobile-content-wrapper' : ''">
    @if (!loading) {
      <router-outlet></router-outlet>
    }
    @if (loading) {
      <div class="mt-spinner-container">
        <loader></loader>
      </div>
    }
  </div>
</mat-sidenav-content>
</mat-sidenav-container>
</div>

@if (showDialler && showCallingWidget) {
  <mt-calling [inputObj]="progressiveCallObj" (onAction)="onCallActions($event)"></mt-calling>
}

<mt-ignosis-transfer></mt-ignosis-transfer>

@if (showDialler && showOzonetelIframeDialer) {
  <mt-ozonetel-iframe></mt-ozonetel-iframe>
}

@if (showDialler && showCubeIframeDialer) {
  <mt-cube-iframe></mt-cube-iframe>
}

@if (logoutModal) {
  <mt-modal [title]="'Are you sure want to logout?'" [contentbody]="contentbody" [buttons]="logOutButtons"
    (onAction)="onLogoutActions($event)">
  </mt-modal>
}

@if (addToHomeModal) {
  <mt-modal [title]="'Do you want to install Moneytor App?'" [buttons]="installbuttons" (onAction)="onAppInit($event)">
  </mt-modal>
}

@if (locationPermission) {
  <mt-modal [title]="' Allow location access'" [buttons]="locationModalButtons"
    (onAction)="onLocationPermission($event)">
    As per your Organization Policy, please allow
    <strong>Location Access</strong> to proceed further.
  </mt-modal>
}

<!-- Modal for sync manager -->
@if (showSyncModal) {
  <mt-modal [title]="'Sync Manager'" [buttons]="syncManagerButtons" (onAction)="syncResponses(0, $event)">
    @if (
      responsesArray && responsesArray.length > 0 && syncingNowMsg === null
      ) {
      <p>
        You have <strong>{{ responsesArray.length }}</strong> update(s) that have
        not been sent to the server. Make sure that you have a valid internet
        connection, then click the button below to send your updates to the
        server.
      </p>
    }
    @if (syncingNowMsg !== null) {
      <mt-h3>{{ syncingNowMsg }}</mt-h3>
    }
    @if (
      responsesArray && responsesArray.length < 1 && syncingNowMsg === null
      ) {
      <mt-h3>
        You don't have any actions to upload
      </mt-h3>
    }
    @if (showProgress()) {
      <div class="mt-stepper-loader-wrap">
        <ul class="sync-loader-wrapper">
          @for (step of loadingSteps; track step) {
            <li class="sync-loader-container">
              <span class="sync-icon">
                <span [class]="step.icon"></span>
              </span>
              <div class="sync-label" [class]="getClassByStatus(step.status)" [innerHTML]="step.label"></div>
            </li>
          }
        </ul>
      </div>
    }
  </mt-modal>
}
